const hideFields = (label, field) => {
  tinymce.DOM.hide(label)
  tinymce.DOM.hide(field)
  tinymce.DOM.setStyles('_parameter_manager', { 'height': '200px'} )
  tinymce.DOM.setStyles('_parameter_manager-body', { 'height': '160px'} )
}

const showFields = (label, field) => {
  tinymce.DOM.show(label)
  tinymce.DOM.show(field)
  tinymce.DOM.setStyles('_parameter_manager', { 'height': '290px'} )
  tinymce.DOM.setStyles('_parameter_manager-body', { 'height': '230px'} )
}

tinymce.PluginManager.add('params', (editor, url) => {
  const parameters = Object.keys(editor.settings.params_items).map( (x) => { return { text: `[%${x}%]`, value: x}; })
  if (parameters.length) {
    editor.addButton('params', {
      tooltip: i18n.t('tinymce.insert_params.title'),
      icon: 'fi fi-params',
      onclick: () => {
        editor.windowManager.open({
          id: '_parameter_manager',
          title: i18n.t('tinymce.insert_params.title'),
          body: [
            {type: 'label', text: i18n.t('tinymce.insert_params.label')},
            {
              type: 'listbox',
              name: 'param',
              values: parameters
            },

            {type: 'label', text: i18n.t('tinymce.insert_params.default')},
            {type: 'textbox', name: 'default'},

            {type: 'label', id: 'date_label', text: i18n.t('tinymce.insert_params.dateformat')},
            {type: 'listbox', id: 'date', name: 'date',
              values: [
                {text: '01.01.2021', value: '%d.%m.%Y'},
                {text: '01.01.2021 21:10', value: '%d.%m.%Y %H:%M'},
                {text: '01.01.2021 21:10:55', value: '%d.%m.%Y %H:%M:%S'}
              ]
            },
          ],
          onselect: (api) => {
            switch(api.target._parent._parent._name) /*👀*/ {
              case 'param':
                let valueKinds = editor.settings.params_items[api.target.settings.value]

                if (valueKinds.includes('date')) {
                  showFields('date_label', 'date')
                } else {
                  hideFields('date_label', 'date')
                }
                break
            }
          },
          onsubmit: function(e) {
            param = e.data.param;
            if(!param)
              return;

            valueKinds = editor.settings.params_items[param]
            if (valueKinds.includes('date')) {
              /* [%birthday~d%d %m %Y|01.01.1970%] */

              param += '~d'
              date = e.data.date
              date ? param += date : param += '%d %m %Y'
            }

            if (e.data.default)
              param += '|' + e.data.default;

            editor.insertContent('[%' + param + '%]');
          }
        });

        if (editor.settings.params_items[parameters[0].value] == 'date') {
          null } else { hideFields('date_label', 'date') }
      }
    });
  }
});
